import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import useReportFindById from '@opsbase/react-gql-hooks/report/useReportFindById';
import useReportUpdate from '@opsbase/react-gql-hooks/report/useReportUpdate';
import Dialog from '@opsbase/web-dialogs/Dialog';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur';
import Button from '@opsbase/web-ui/Button';
import React, { useCallback } from 'react';
export function ReportEditDialog() {
    const { viewId } = useParams();
    const { goTo } = useNav();
    const updateReport = useReportUpdate();
    const { loading, data: report } = useReportFindById({
        variables: { id: viewId },
    });
    const handleChangeTitle = useCallback(title => {
        updateReport({ id: viewId, patch: { title } }).catch(doNothing);
    }, [viewId, updateReport]);
    const handleDelete = useCallback(() => {
        goTo(Pages.REPORT_DELETE, { viewId });
    }, [goTo, viewId]);
    return (React.createElement(Dialog, { title: i18n.t('edit-savedview'), padded: true, loading: loading, buttonsLeft: React.createElement(Button, { color: Palette.error, label: i18n.t('delete-savedview'), onClick: handleDelete }) }, report && (React.createElement(TextFieldWithStateAndBlur, { white: true, label: i18n.t('title'), autoFocus: true, value: report.title, onBlur: handleChangeTitle, fullWidth: true }))));
}
export default ReportEditDialog;
